export const ORDER_STATUS = {
  INQUIRY:1,
  QUOTE:2,
}
export const QUOTE_RESULT = {
  DONE:203,
  HAVE_NOT_DONE:202,
  TEMPORARY_STORAGE:204,
}
export const repairFactoryDetailReturnUrlArr = [
  { key: 'SECONDS_REPORT', value: 301, cn_name: '秒报', },
  { key: 'STAGING', value: 302, cn_name: '暂存', },
  { key: 'DENY_SEE', value: 303, cn_name: '修理厂不可见此询价单', },
  { key: 'NONE_THIS_INQUIRY', value: 304, cn_name: '未找到此询价单', },
]
export const repairFactoryDetailReturnUrlResult = repairFactoryDetailReturnUrlArr.reduce((total, item)=>{
  total[item.key] = item.value
  return total
},{})